import { Injectable } from "@angular/core";
import { CreateBookingWS } from "@app/core/booking/data/network/create-booking.ws";
import { BookingRepo } from "@app/core/booking/domain/booking-repo";
import { Booking } from "@app/core/booking/domain/model/booking";
import { OpenBrowserUrlRepo } from "@app/core/open-browser-url/domain/open-browser-url.repo";
import { BrowserCapacitor } from "@app/core/open-browser-url/infrastructure/capacitor/browser.capacitor";

import { Observable } from "rxjs";

@Injectable()
export class OpenBrowserUrlRepoImpl implements OpenBrowserUrlRepo {
  constructor(private browserCapacitor: BrowserCapacitor) {}

  open(url: string): Observable<boolean> {
    return this.browserCapacitor.execute(url);
  }
}
